<template>
  <section class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('addEditFournisseurs.adresse.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-6">
          <b-field :label="$t('addEditFournisseurs.adresse.postalAddress')">
            <app-adresse
              :adresse="fournisseur.adressePostale"
              :tableName="constantes.TIERS"
              adresseName='adressePostale'/>
          </b-field>
        </div>
        <div class="column is-6">
          <span>
            <qd-checkbox
              v-model="fournisseur.adresseFacturationDifferente"
              @input="selectionAdresseFacturationclient()">
              {{ $t('addEditFournisseurs.adresse.addressBillingDifferent')}}
            </qd-checkbox>
            <app-adresse
              v-if="fournisseur.adresseFacturationDifferente"
              :adresse="fournisseur.adresseFacturation"
              :tableName="constantes.TIERS"
              adresseName="adresseFacturation"
              class="mgt-5px"/>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import adresseGenerer from '@/services/general/genererAdresse';
import { TIERS } from '@/configuration/ville/villeConf';
import AppAdresse from '@/components/general/adresse';

export default {
  name: 'AdresseFournisseurs',
  props: {
    fournisseur: {
      type: Object,
      required: true,
    },
  },
  components: {
    AppAdresse,
  },
  data() {
    return {
      constantes: {
        TIERS,
      },
    };
  },
  methods: {
    selectionAdresseFacturationclient() {
      if (!this.fournisseur.adresseFacturationDifferente) {
        this.fournisseur.adresseFacturation = adresseGenerer();
      }
    },
  },
};
</script>
